import { render } from "./ModalApprovalDelegateEditor.vue?vue&type=template&id=cc2cedd2"
import script from "./ModalApprovalDelegateEditor.vue?vue&type=script&lang=js"
export * from "./ModalApprovalDelegateEditor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__